export default {
  ownedPlaces: [],
  places: [],
  place: {},
  totalSpots: 0,
  availableSpots: 0,
  sessions: [],
  nextAvailablePage: undefined
}
